// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";

function ClientOnly(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsBrowser = match[1];
  React.useEffect((function () {
          Curry._1(setIsBrowser, (function (param) {
                  return true;
                }));
        }), []);
  if (match[0]) {
    return props.children;
  } else {
    return null;
  }
}

var make = ClientOnly;

export {
  make ,
}
/* react Not a pure module */
